/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DiskUtilizationWorkspaceConfiguration {
    getFixupPrototypeFunction() { return DiskUtilizationWorkspaceConfiguration.fixupPrototype; }

    static newInstance(model: Partial<DiskUtilizationWorkspaceConfiguration>): DiskUtilizationWorkspaceConfiguration {
        let obj = Object.assign(new DiskUtilizationWorkspaceConfiguration(), model);
        DiskUtilizationWorkspaceConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DiskUtilizationWorkspaceConfiguration>): DiskUtilizationWorkspaceConfiguration {
        if (!model) return null;
        return DiskUtilizationWorkspaceConfiguration.newInstance(<DiskUtilizationWorkspaceConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DiskUtilizationWorkspaceConfiguration) {
        if (!obj) return;

        models.DiskUtilizationWorkspaceConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DiskUtilizationWorkspaceConfiguration): boolean {
        Object.setPrototypeOf(obj, DiskUtilizationWorkspaceConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Log Analytics Workspace Ids
     */
    workspace_ids: Array<string>;

    /**
     * Service Account Id
     */
    service_account_id: string;

}
